import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {CategoriesNavLinkStyled, CategoriesNavStyled, CategoryWrapper} from './CategoriesNav.style';
import {Sticky} from 'react-sticky';

export class CategoriesNav extends PureComponent {
  render() {
    const {categories, isMobile, isTemplateLight} = this.props;
    const renderCategories =
      categories.map(category =>
        <CategoriesNavLinkStyled
          key={category.name}
          href={`#${category.name}`}
          data-rw="menu-page--category-link"
          data-rw-meta={`menu-page--category-link ${category.name}`}
          isTemplateLight={isTemplateLight}
        >
          {category.name}
        </CategoriesNavLinkStyled>
      );
    const stickerFunc = ({style}) => {
      let extraStyle = {
        maxHeight: '100vh',
        overflowX: 'hidden',
        overflowY: 'auto'
      };
      if (isTemplateLight) {
        extraStyle = Object.assign({}, extraStyle, {
          display: 'flex',
          flexWrap: 'wrap',
          textAlign: 'center',
          maxWidth: '77.6rem'
        });
      }
      const newStyle = Object.assign({}, style, extraStyle);
      return (
        <CategoryWrapper
          style={newStyle}
          isTemplateLight={isTemplateLight}
        >
          {renderCategories}
        </CategoryWrapper>
      );
    };
    const renderStickyDiv = isMobile ? renderCategories :
      (<Sticky>
        {stickerFunc}
      </Sticky>);

    return (
      <CategoriesNavStyled data-rw="category-menu--component">
        {renderStickyDiv}
      </CategoriesNavStyled>
    );
  }
}

CategoriesNav.propTypes = {
  categories: PropTypes.array,
  isMobile: PropTypes.bool.isRequired,
  isTemplateLight: PropTypes.bool
};

export default CategoriesNav;



// WEBPACK FOOTER //
// ./containers/MenuPage/CategoriesNav.js